import type { Routes, UrlMatchResult, UrlSegment } from '@angular/router';

import { urlMatcher } from '#shell/utils/url-matcher';

enum ScanRoute {
    NFC = 'nfc',
    LEAVE_A_REVIEW = 'leave-a-review',
}

export function scanMatcher(segments: UrlSegment[]): UrlMatchResult | null {
    return urlMatcher(segments, ScanRoute);
}

export const SCAN_ROUTES: Routes = [
    {
        path: ScanRoute.NFC,
        loadComponent: () => import('#modules/scan/views/scan/scan.component').then((m) => m.ScanComponent),
    },
    {
        path: ScanRoute.LEAVE_A_REVIEW,
        loadComponent: () =>
            import('#modules/scan/views/scan-private-review/scan-private-review.component').then((m) => m.ScanPrivateReviewComponent),
    },
];
